import {createSettings} from '../modules/recordskeeper-ai/core/_requests'
import {useAuth} from '../modules/auth'
import {toast} from 'react-toastify'

export const useUpdateSettingsData = () => {
  const {companyId} = useAuth()

  const updateSettings = async (payload?: any) => {
    if (!companyId) return

    try {
      const {
        data: {success, errors},
      } = await createSettings(companyId, payload || {})

      if (!success) {
        toast.error(errors[0])
      }
    } catch (err) {
      console.error(err)
    } finally {
    }
  }

  return {
    updateSettings,
  }
}
